import React, { useContext } from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import { Route, Redirect, Switch, HashRouter } from 'react-router-dom';

import Nav from './Components/Nav/Nav';
import { Footer } from './Components/Footer';
import { WelcomePage } from './Pages/WelcomePage';
import { IconsPage } from './Pages/IconsPage';
import { ColoursPage } from './Pages/ColoursPage';
import { PlayPage } from './Pages/PlayPage';
import { StoryPage } from './Components/Story/StoryPage';
import { NotFoundPage } from './Pages/NotFoundPage';
import VisualTestsPage from './Pages/VisualTestsPage';
import { FormikExample } from './Pages/FormikExample';
import { ReactHookFormExamplev6 } from './Pages/ReactHookFormsExamplev6';
import { darkModeContext } from './darkModeContext';

const App: React.FC = () => {
  const docsDarkMode = useContext(darkModeContext);
  const docsDarkModeValue = docsDarkMode.value || false;

  return (
    <HashRouter>
      <div
        css={css`
          display: flex;
        `}
      >
        {window.location.hash.toLowerCase().indexOf('visualtests') === -1 && <Nav />}
        <div css={getCssMainRouter(docsDarkModeValue)}>
          <Switch>
            <Redirect from="/home" to="/" />
            <Redirect from="/welcome" to="/" />
            <Route exact path="/" component={WelcomePage} />
            <Route exact path="/icons" component={IconsPage} />
            <Route exact path="/colours" component={ColoursPage} />
            <Route exact path="/play" component={PlayPage} />
            <Route exact path="/formik" component={FormikExample} />
            <Route exact path="/reacthookformsv6" component={ReactHookFormExamplev6} />
            <Route exact path="/story" component={StoryPage} />
            <Route exact path="/visualtests" component={VisualTestsPage} />
            <Route component={NotFoundPage} />
          </Switch>
          {window.location.hash.toLowerCase().indexOf('visualtests') === -1 && <Footer />}
        </div>
      </div>
    </HashRouter>
  );
};

export default App;

function getCssMainRouter(darkModeCont: boolean) {
  return css`
    box-sizing: border-box;
    flex-grow: 1;
    height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background-color: ${darkModeCont ? '#1c1c1c' : '#f7fafc'};
  `;
}
